module.exports = __webpack_public_path__ + "static/QLD-97a2fd505c5583777e18f5420a1d3d1b.svg";